import React, {useContext, useEffect, useRef, useState} from "react";
import {withRouter} from "react-router";
import logoIconWhite from "../../assets/images/icons/logo_icon_white.svg";

import BrandAndModelSearch from "../../components/ProductSearchField/BrandAndModelSearch";
import MultipleItemsSearchSelect from "../../components/ProductSearchField/MultipleItemsSearchSelect";
import RangeSelect from "../../components/ProductSearchField/RangeSelect";
import MenuCheckbox from "../../components/ProductMenu/MenuCheckbox";
import ColorPicker from "./ColorPicker";
import RangeSlider from "./RangeSlider";

import {SearchOptionsContext} from "../../context/search-options-context";
import {CustomerTypeContext} from "../../context/customer-type-context";

import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import {TextField, Typography} from "@material-ui/core";
import FormattedDateInput from "../../components/FormattedDateInput/FormattedDateInput";
import SortSelect from "./SortSelect";

const ENGINE_CAPACITY_STEPS = [1000, 1200, 1400, 1600, 1800, 2000, 2200, 2500, 3000, 3500, 4000, 5000];

function FiltersBar(props) {

    let searchOptions = useContext(SearchOptionsContext);
    const searchOptionsForDeliveryCars = searchOptions.deliveryCars;
    const searchOptionsForPassengerCars = searchOptions.passengerCars;

    const [extended, setExtended] = useState(false);
    const [budgetMode, setBudgetMode] = useState("RATA");

    const [customerType, setCustomerType, availableCustomerTypes] = useContext(CustomerTypeContext);

    useEffect(() => {
        const params = new URLSearchParams(props.location.search);
        if (params.get("extended") === "1" || params.get("filterClicked") === "true") setExtended(true);
    }, []);

    const prevPageRef = useRef(1);
    useEffect(() => {
        const page = parseInt(new URLSearchParams(props.location.search).get("page") || "1", 10);
        if (page !== prevPageRef.current) {
            if (page > 1) setExtended(false);
            prevPageRef.current = page;
        }
    }, [props.location.search]);

    const changeSpecialOfferHandler = (event) => {
        props.setSearchParameters(prev => ({...prev, specialOffer: event.target.checked ? true : null}));
    };

    const changeIsPremiumHandler = (event) => {
        props.setSearchParameters(prev => ({...prev, isPremium: event.target.checked ? true : null}));
    };

    const changeAvailabilityOnStockHandler = (event) => {
        props.setSearchParameters(prev => ({
            ...prev, availability: event.target.checked ? "IN_STOCK" : null
        }));
    };

    const changeBudgetHandler = (budget) => {
        if (customerType === searchOptions.customerTypes[0]) {
            props.setSearchParameters(prev => ({
                ...prev,
                installmentNetFrom: budget.from, installmentNetTo: budget.to,
                installmentGrossFrom: null, installmentGrossTo: null
            }));
        } else {
            props.setSearchParameters(prev => ({
                ...prev,
                installmentGrossFrom: budget.from, installmentGrossTo: budget.to,
                installmentNetFrom: null, installmentNetTo: null
            }));
        }
    };

    const changeMinimumPriceHandler = (minimumPrice) => {
        if (customerType === searchOptions.customerTypes[0]) {
            props.setSearchParameters(prev => ({
                ...prev,
                minimumSellPriceNetFrom: minimumPrice.from, minimumSellPriceNetTo: minimumPrice.to,
                minimumSellPriceGrossFrom: null, minimumSellPriceGrossTo: null
            }));
        } else {
            props.setSearchParameters(prev => ({
                ...prev,
                minimumSellPriceNetFrom: null, minimumSellPriceNetTo: null,
                minimumSellPriceGrossFrom: minimumPrice.from, minimumSellPriceGrossTo: minimumPrice.to
            }));
        }
    };

    const changeEnginePowerHandler = (power) => {
        props.setSearchParameters(prev => ({
            ...prev, enginePowerHpFrom: power.from, enginePowerHpTo: power.to
        }));
    };

    const changeEngineCapacityHandler = (capacity) => {
        props.setSearchParameters(prev => ({
            ...prev, engineCapacityFrom: capacity.from, engineCapacityTo: capacity.to
        }));
    };

    const changePropertyHandler = (propertyName, value) => {
        props.setSearchParameters(prev => ({...prev, [propertyName]: value}));
    };

    const changeMileageHandler = (mileage) => {
        props.setSearchParameters(prev => ({
            ...prev, mileageFrom: mileage.from, mileageTo: mileage.to
        }));
    };

    const changeManufactureYearHandler = (manufactureYear) => {
        props.setSearchParameters(prev => ({
            ...prev, manufactureYearFrom: manufactureYear.from, manufactureYearTo: manufactureYear.to
        }));
    };

    const changeNipHandler = (event) => {
        props.setSearchParameters(prev => ({...prev, nip: event.target.value}));
    };

    const changeGuardianCodeHandler = (event) => {
        props.setSearchParameters(prev => ({...prev, guardianCode: event.target.value}));
    };

    const changeCreatedFromHandler = (event) => {
        props.setSearchParameters(prev => ({
            ...prev, createdFrom: event !== null ? event.toISOString().split("T")[0] : ""
        }));
    };

    const changeCreatedToHandler = (event) => {
        props.setSearchParameters(prev => ({
            ...prev, createdTo: event !== null ? event.toISOString().split("T")[0] : ""
        }));
    };

    const vehicleTypeHandler = (type) => {
        const updatedParameters = {...props.initialState, vehicleTypes: type};
        props.setSearchParameters(updatedParameters);

        props.history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString(
                updatedParameters, "", new URLSearchParams(props.location.search).get("extended") === "1"
            )
        });
    };

    const searchButtonClicked = () => {
        props.history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString(props.searchParameters, "", new URLSearchParams(props.location.search).get("extended") === "1")
        });
    };

    const clearButtonClicked = () => {
        props.setSearchParameters(props.initialState);
        props.history.push({
            search: customerType === availableCustomerTypes.company
                ? "?vehicleTypes=OSOBOWE&customerType=COMPANY"
                : "?vehicleTypes=OSOBOWE&customerType=PERSON"
        });
    };

    let installmentRange = {from: props.searchParameters.installmentNetFrom, to: props.searchParameters.installmentNetTo};
    let sellPriceRange   = {from: props.searchParameters.minimumSellPriceNetFrom, to: props.searchParameters.minimumSellPriceNetTo};

    if (customerType !== searchOptions.customerTypes.company) {
        installmentRange = {from: props.searchParameters.installmentGrossFrom, to: props.searchParameters.installmentGrossTo};
        sellPriceRange   = {from: props.searchParameters.minimumSellPriceGrossFrom, to: props.searchParameters.minimumSellPriceGrossTo};
    }

    const engineHpPowerRange   = {from: props.searchParameters.enginePowerHpFrom, to: props.searchParameters.enginePowerHpTo};
    const engineCapacityRange  = {from: props.searchParameters.engineCapacityFrom, to: props.searchParameters.engineCapacityTo};
    const manufactureYearRange  = {from: props.searchParameters.manufactureYearFrom, to: props.searchParameters.manufactureYearTo};
    const mileageRange          = {from: props.searchParameters.mileageFrom, to: props.searchParameters.mileageTo};

    if (props.searchParameters.vehicleTypes === "DOSTAWCZE") {
        searchOptions = searchOptionsForDeliveryCars;
    } else {
        searchOptions = searchOptionsForPassengerCars;
    }

    const isDelivery  = props.searchParameters.vehicleTypes === "DOSTAWCZE";
    const isCompany   = customerType === availableCustomerTypes.company;
    const isPerson    = !isCompany;

    return (
        <div className="filters-bar">

            <div className="filters-bar__breadcrumbs">
                <a href="/" className="filters-bar__breadcrumb-link">go-auto.pl</a>
                <i className="fa fa-chevron-right filters-bar__breadcrumb-sep"></i>
                <span>Wszystkie oferty</span>
            </div>

            <div className="filters-bar__heading-wrap">
                <h1 className="filters-bar__heading">
                    Wybierz swój samochód spośród{" "}
                    <span className="filters-bar__heading-count">{props.offersNumber}</span>{" "}
                    ofert
                </h1>
            </div>

            <div className="filters-bar__main">

                <div className="filters-bar__form-header">
                    <div className="filters-bar__tabs">
                        <button
                            type="button"
                            className={"filters-bar__tab" + (!isDelivery ? " filters-bar__tab--active" : "")}
                            onClick={() => vehicleTypeHandler("OSOBOWE")}
                        >
                            <span className="search-tab-icon search-tab-icon--car"/> OSOBOWE
                        </button>
                        <button
                            type="button"
                            className={"filters-bar__tab" + (isDelivery ? " filters-bar__tab--active" : "")}
                            onClick={() => vehicleTypeHandler("DOSTAWCZE")}
                        >
                            <span className="search-tab-icon search-tab-icon--truck"/> DOSTAWCZE
                        </button>
                    </div>

                    <button type="button" className="filters-bar__clear-btn" onClick={clearButtonClicked}>
                        <i className="fa fa-times"></i> WYCZYŚĆ FILTRY
                    </button>
                </div>

                <div className="filters-bar__form">

                    {!extended && (
                        <>
                            <div className="filters-bar__row filters-bar__row--basic">
                                <div className="search-toggle-row fb-toggle-col">
                                    <span className={"search-toggle-label" + (isCompany ? " active" : "")}>FIRMA</span>
                                    <button
                                        type="button"
                                        className="search-toggle-switch"
                                        onClick={() => setCustomerType(
                                            isCompany ? availableCustomerTypes.person : availableCustomerTypes.company
                                        )}
                                        aria-label="Zmień typ klienta"
                                    >
                                        <span className={"search-toggle-knob" + (isPerson ? " right" : "")}/>
                                    </button>
                                    <span className={"search-toggle-label" + (isPerson ? " active" : "")}>KONSUMENT</span>
                                </div>
                                <BrandAndModelSearch
                                    brandsAndModels={searchOptions.brandsAndModels}
                                    selectedBrands={props.searchParameters.brands}
                                    selectedModels={props.searchParameters.models}
                                    resetBrands={props.searchParameters.brands.length === 0}
                                    onBrandChange={(brands) => changePropertyHandler("brands", brands)}
                                    onModelChange={(models) => changePropertyHandler("models", models)}
                                    placeholderForBrands="Marka"
                                    placeholderForModelss="Model"/>
                                <MultipleItemsSearchSelect
                                    items={searchOptions.bodyTypes}
                                    selectedItems={props.searchParameters.bodyTypes}
                                    resetSelected={props.searchParameters.bodyTypes.length === 0}
                                    onChange={(bodyTypes) => changePropertyHandler("bodyTypes", bodyTypes)}
                                    placeholder="Nadwozie"/>
                                <MultipleItemsSearchSelect
                                    items={searchOptions.fuelTypes}
                                    selectedItems={props.searchParameters.fuelTypes}
                                    resetSelected={props.searchParameters.fuelTypes.length === 0}
                                    onChange={(fuelTypes) => changePropertyHandler("fuelTypes", fuelTypes)}
                                    placeholder="Paliwo"/>
                            </div>

                            <div className="filters-bar__row filters-bar__row--budget">
                                <div className="search-toggle-row fb-toggle-col">
                                    <span className={"search-toggle-label" + (budgetMode === "CENA" ? " active" : "")}>CENA</span>
                                    <button
                                        type="button"
                                        className="search-toggle-switch"
                                        onClick={() => setBudgetMode(budgetMode === "RATA" ? "CENA" : "RATA")}
                                        aria-label="Przełącz między ceną a ratą"
                                    >
                                        <span className={"search-toggle-knob" + (budgetMode === "RATA" ? " right" : "")}/>
                                    </button>
                                    <span className={"search-toggle-label" + (budgetMode === "RATA" ? " active" : "")}>RATA</span>
                                </div>
                                <div className="fb-range-col">
                                    {budgetMode === "RATA" ? (
                                        <RangeSlider
                                            onChange={changeBudgetHandler}
                                            items={searchOptions.installments || []}
                                            range={installmentRange}
                                            unit="zł"
                                            placeholder={["Rata od", "Rata do"]}/>
                                    ) : (
                                        <RangeSlider
                                            onChange={changeMinimumPriceHandler}
                                            items={searchOptions.prices || []}
                                            range={sellPriceRange}
                                            unit="zł"
                                            placeholder={["Cena od", "Cena do"]}/>
                                    )}
                                </div>
                                <div className="fb-checkbox-col">
                                    <MenuCheckbox
                                        name="onlyNew"
                                        checked={props.searchParameters.newUsed === "new"}
                                        selected={(e) => changePropertyHandler("newUsed", e.target.checked ? "new" : "all")}
                                    >Tylko nowe auta</MenuCheckbox>
                                </div>
                                <div className="fb-apply-col">
                                    <button type="button" className="filters-bar__apply-btn" onClick={searchButtonClicked}>
                                        ZASTOSUJ FILTRY <img src={logoIconWhite} alt="" className="search-btn-icon"/>
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    {extended && (
                        <>
                            <div className="filters-bar__row filters-bar__row--budget filters-bar__row--budget-ext">
                                <div className="search-toggle-row fb-toggle-col">
                                    <span className={"search-toggle-label" + (isCompany ? " active" : "")}>FIRMA</span>
                                    <button
                                        type="button"
                                        className="search-toggle-switch"
                                        onClick={() => setCustomerType(
                                            isCompany ? availableCustomerTypes.person : availableCustomerTypes.company
                                        )}
                                        aria-label="Zmień typ klienta"
                                    >
                                        <span className={"search-toggle-knob" + (isPerson ? " right" : "")}/>
                                    </button>
                                    <span className={"search-toggle-label" + (isPerson ? " active" : "")}>KONSUMENT</span>
                                </div>
                                <div className="search-toggle-row fb-toggle-col">
                                    <span className={"search-toggle-label" + (budgetMode === "CENA" ? " active" : "")}>CENA</span>
                                    <button
                                        type="button"
                                        className="search-toggle-switch"
                                        onClick={() => setBudgetMode(budgetMode === "RATA" ? "CENA" : "RATA")}
                                        aria-label="Przełącz między ceną a ratą"
                                    >
                                        <span className={"search-toggle-knob" + (budgetMode === "RATA" ? " right" : "")}/>
                                    </button>
                                    <span className={"search-toggle-label" + (budgetMode === "RATA" ? " active" : "")}>RATA</span>
                                </div>
                                <div className="fb-range-col">
                                    {budgetMode === "RATA" ? (
                                        <RangeSlider
                                            onChange={changeBudgetHandler}
                                            items={searchOptions.installments || []}
                                            range={installmentRange}
                                            unit="zł"
                                            placeholder={["Rata od", "Rata do"]}/>
                                    ) : (
                                        <RangeSlider
                                            onChange={changeMinimumPriceHandler}
                                            items={searchOptions.prices || []}
                                            range={sellPriceRange}
                                            unit="zł"
                                            placeholder={["Cena od", "Cena do"]}/>
                                    )}
                                </div>
                            </div>

                            <div className="filters-bar__row filters-bar__row--ext-brands">
                                <BrandAndModelSearch
                                    brandsAndModels={searchOptions.brandsAndModels}
                                    selectedBrands={props.searchParameters.brands}
                                    selectedModels={props.searchParameters.models}
                                    resetBrands={props.searchParameters.brands.length === 0}
                                    onBrandChange={(brands) => changePropertyHandler("brands", brands)}
                                    onModelChange={(models) => changePropertyHandler("models", models)}
                                    placeholderForBrands="Marka"
                                    placeholderForModelss="Model"/>
                                <MultipleItemsSearchSelect
                                    items={searchOptions.bodyTypes}
                                    selectedItems={props.searchParameters.bodyTypes}
                                    resetSelected={props.searchParameters.bodyTypes.length === 0}
                                    onChange={(bodyTypes) => changePropertyHandler("bodyTypes", bodyTypes)}
                                    placeholder="Nadwozie"/>
                                <MultipleItemsSearchSelect
                                    items={searchOptions.fuelTypes}
                                    selectedItems={props.searchParameters.fuelTypes}
                                    resetSelected={props.searchParameters.fuelTypes.length === 0}
                                    onChange={(fuelTypes) => changePropertyHandler("fuelTypes", fuelTypes)}
                                    placeholder="Paliwo"/>
                            </div>
                        </>
                    )}

                    {extended && (
                        <div className="filters-bar__extended">

                            <div className="filters-bar__ext-grid">

                                <div>
                                    <MultipleItemsSearchSelect
                                        items={searchOptions.segments}
                                        selectedItems={props.searchParameters.segments}
                                        resetSelected={props.searchParameters.segments.length === 0}
                                        onChange={(segments) => changePropertyHandler("segments", segments)}
                                        placeholder="Segment (typ)"/>
                                </div>
                                <div className="fb-span2">
                                    <RangeSelect
                                        onChange={changeManufactureYearHandler}
                                        items={searchOptions.manufactureYears}
                                        range={manufactureYearRange}
                                        reverseValuesList
                                        unit=""
                                        placeholder={["Rok produkcji od", "Rok produkcji do"]}/>
                                </div>
                                <div className="fb-span2">
                                    <RangeSelect
                                        onChange={changeMileageHandler}
                                        items={searchOptions.mileages}
                                        range={mileageRange}
                                        unit="km"
                                        placeholder={["Przebieg od", "Przebieg do"]}/>
                                </div>

                                <div>
                                    <MultipleItemsSearchSelect
                                        items={searchOptions.gearboxTypes}
                                        selectedItems={props.searchParameters.gearboxTypes}
                                        resetSelected={props.searchParameters.gearboxTypes.length === 0}
                                        onChange={(gearboxTypes) => changePropertyHandler("gearboxTypes", gearboxTypes)}
                                        placeholder="Skrzynia biegów"/>
                                </div>
                                <div>
                                    <MultipleItemsSearchSelect
                                        items={searchOptions.driveTypes}
                                        selectedItems={props.searchParameters.driveTypes}
                                        resetSelected={props.searchParameters.driveTypes.length === 0}
                                        onChange={(driveTypes) => changePropertyHandler("driveTypes", driveTypes)}
                                        placeholder="Napęd"/>
                                </div>
                                <div className="fb-span2">
                                    <RangeSelect
                                        onChange={changeEnginePowerHandler}
                                        items={searchOptions.enginePowerHp}
                                        range={engineHpPowerRange}
                                        unit="KM"
                                        placeholder={["Moc silnika od", "Moc silnika do"]}/>
                                </div>
                                <div>
                                    <ColorPicker
                                        items={searchOptions.colors}
                                        selectedItems={props.searchParameters.colors}
                                        onChange={(colors) => changePropertyHandler("colors", colors)}/>
                                </div>

                                <div>
                                    <MultipleItemsSearchSelect
                                        items={searchOptions.numbersOfDoors.map(item => item.toString())}
                                        selectedItems={props.searchParameters.numberOfDoors}
                                        resetSelected={props.searchParameters.numberOfDoors.length === 0}
                                        onChange={(numberOfDoors) => changePropertyHandler("numberOfDoors", numberOfDoors)}
                                        placeholder="Liczba drzwi"/>
                                </div>
                                <div>
                                    <MultipleItemsSearchSelect
                                        items={searchOptions.numbersOfSeats.map(item => item.toString())}
                                        selectedItems={props.searchParameters.numberOfSeats}
                                        resetSelected={props.searchParameters.numberOfSeats.length === 0}
                                        onChange={(numberOfSeats) => changePropertyHandler("numberOfSeats", numberOfSeats)}
                                        placeholder="Liczba siedzeń"/>
                                </div>
                                <div>
                                    <MultipleItemsSearchSelect
                                        items={searchOptions.calculationTypes}
                                        selectedItems={props.searchParameters.calculationTypes}
                                        resetSelected={props.searchParameters.calculationTypes.length === 0}
                                        onChange={(calculationTypes) => changePropertyHandler("calculationTypes", calculationTypes)}
                                        placeholder="Forma finansowania"/>
                                </div>
                                <div className="fb-span2">
                                    <RangeSelect
                                        onChange={changeEngineCapacityHandler}
                                        items={ENGINE_CAPACITY_STEPS}
                                        range={engineCapacityRange}
                                        unit="cm³"
                                        placeholder={["Pojemność silnika od", "Pojemność silnika do"]}/>
                                </div>

                                {(() => {
                                    const isNewChecked = props.searchParameters.newUsed === "new";
                                    const isUsedChecked = props.searchParameters.newUsed === "used";
                                    const toggleNew = () => {
                                        const nextIsNew = !isNewChecked;
                                        changePropertyHandler("newUsed", nextIsNew ? (isUsedChecked ? "all" : "new") : (isUsedChecked ? "used" : "all"));
                                    };
                                    const toggleUsed = () => {
                                        const nextIsUsed = !isUsedChecked;
                                        changePropertyHandler("newUsed", nextIsUsed ? (isNewChecked ? "all" : "used") : (isNewChecked ? "new" : "all"));
                                    };
                                    return (
                                        <div className="fb-span5 filters-bar__check-group">
                                            <div className="filters-bar__group-label">Stan pojazdu</div>
                                            <div className="filters-bar__check-list">
                                                <div className="search-checkbox-row">
                                                    <input type="checkbox" id="fb-condition-new" checked={isNewChecked} onChange={toggleNew}/>
                                                    <label htmlFor="fb-condition-new">Nowy</label>
                                                </div>
                                                <div className="search-checkbox-row">
                                                    <input type="checkbox" id="fb-condition-used" checked={isUsedChecked} onChange={toggleUsed}/>
                                                    <label htmlFor="fb-condition-used">Używany</label>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })()}

                                {searchOptions.equipment && searchOptions.equipment.length > 0 && (() => {
                                    const selEq = (props.searchParameters.equipment || []).map(e =>
                                        typeof e === "object" ? e.name : String(e)
                                    );
                                    const toggleEquipment = (name) => {
                                        if (selEq.includes(name)) {
                                            changePropertyHandler("equipment", selEq.filter(e => e !== name));
                                        } else {
                                            changePropertyHandler("equipment", [...selEq, name]);
                                        }
                                    };
                                    return (
                                        <div className="fb-span5 filters-bar__check-group">
                                            <div className="filters-bar__group-label">Wyposażenie</div>
                                            <div className="filters-bar__check-list">
                                                {searchOptions.equipment.map(item => {
                                                    const name = item.toString();
                                                    const id = "fb-eq-" + name.replace(/\s+/g, "-");
                                                    return (
                                                        <div key={name} className="search-checkbox-row">
                                                            <input
                                                                type="checkbox"
                                                                id={id}
                                                                checked={selEq.includes(name)}
                                                                onChange={() => toggleEquipment(name)}
                                                            />
                                                            <label htmlFor={id}>{name}</label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })()}

                                {new URLSearchParams(props.location.search).get("extended") === "1" && (
                                    <React.Fragment>
                                        <div className="fb-span5">
                                            <Typography variant="subtitle2" className="filters-bar__admin-title">
                                                Rozszerzone filtry
                                            </Typography>
                                        </div>
                                        <div>
                                            <TextField fullWidth value={props.searchParameters.nip} onChange={changeNipHandler} placeholder="NIP dostawcy" variant="outlined" size="small"/>
                                        </div>
                                        <div>
                                            <TextField fullWidth value={props.searchParameters.guardianCode} onChange={changeGuardianCodeHandler} placeholder="Kod opiekuna" variant="outlined" size="small"/>
                                        </div>
                                        <div>
                                            <MultipleItemsSearchSelect
                                                items={["VEHIS", "ADMIN", "AKOL", "MAZUREK", "CARET"]}
                                                selectedItems={props.searchParameters.sources}
                                                resetSelected={props.searchParameters.sources.length === 0}
                                                onChange={(sources) => changePropertyHandler("sources", sources)}
                                                placeholder="Źródło ofert"/>
                                        </div>
                                        <div className="filtersDateInput">
                                            <FormattedDateInput
                                                name="createdFrom" showOnlyPast={true}
                                                value={props.searchParameters.createdFrom !== "" && props.searchParameters.createdFrom != null ? new Date(props.searchParameters.createdFrom) : null}
                                                onChange={changeCreatedFromHandler} placeHolder="Data utworzenia od" fullWidth/>
                                        </div>
                                        <div className="filtersDateInput">
                                            <FormattedDateInput
                                                name="createdTo" showOnlyPast={false}
                                                value={props.searchParameters.createdTo !== "" && props.searchParameters.createdTo != null ? new Date(props.searchParameters.createdTo) : null}
                                                onChange={changeCreatedToHandler} placeHolder="Data utworzenia do"/>
                                        </div>
                                    </React.Fragment>
                                )}

                            </div>

                            <div className="filters-bar__ext-bottom">
                                <div className="filters-bar__check-group">
                                    <div className="filters-bar__group-label">Dodatkowe oznaczenia</div>
                                    <div className="filters-bar__check-list">
                                        <div className="search-checkbox-row">
                                            <input type="checkbox" id="fb-specialOffer" checked={!!props.searchParameters.specialOffer} onChange={changeSpecialOfferHandler}/>
                                            <label htmlFor="fb-specialOffer" className="filters-bar__label-red">Oferta specjalna</label>
                                        </div>
                                        <div className="search-checkbox-row">
                                            <input type="checkbox" id="fb-isPremium" checked={!!props.searchParameters.isPremium} onChange={changeIsPremiumHandler}/>
                                            <label htmlFor="fb-isPremium">Tylko premium</label>
                                        </div>
                                        <div className="search-checkbox-row">
                                            <input type="checkbox" id="fb-availability" checked={props.searchParameters.availability === "IN_STOCK"} onChange={changeAvailabilityOnStockHandler}/>
                                            <label htmlFor="fb-availability">Dostępne "od ręki"</label>
                                        </div>
                                        <div className="search-checkbox-row">
                                            <input type="checkbox" id="fb-onlyNew" checked={props.searchParameters.newUsed === "new"} onChange={(e) => changePropertyHandler("newUsed", e.target.checked ? "new" : "all")}/>
                                            <label htmlFor="fb-onlyNew">Tylko nowe auta</label>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" className="filters-bar__apply-btn" onClick={searchButtonClicked}>
                                    ZASTOSUJ FILTRY <img src={logoIconWhite} alt="" className="search-btn-icon"/>
                                </button>
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <div className="filters-bar__underbar">
                <button
                    type="button"
                    className={"filters-bar__expand-btn" + (extended ? " filters-bar__expand-btn--open" : "")}
                    onClick={() => setExtended(!extended)}
                >
                    <i className={"fa " + (extended ? "fa-chevron-up" : "fa-chevron-down")}></i>
                    {extended ? " WRÓĆ DO FILTRÓW PODSTAWOWYCH" : " ROZWIŃ WIĘCEJ FILTRÓW"}
                </button>

                <div className="filters-bar__view-sort">
                    <span className="filters-bar__view-label">Zmień widok</span>
                    <span
                        className={"filters-bar__view-icon" + (props.viewType === "grid-view" ? " filters-bar__view-icon--active" : "")}
                        onClick={() => props.onViewTypeChange("grid-view")}
                        title="Widok siatki"
                    ><i className="fa fa-th"></i></span>
                    <span
                        className={"filters-bar__view-icon" + (props.viewType === "list-view" ? " filters-bar__view-icon--active" : "")}
                        onClick={() => props.onViewTypeChange("list-view")}
                        title="Widok listy"
                    ><i className="fa fa-list-ul"></i></span>
                    <SortSelect />
                </div>
            </div>

            <div className="filters-bar__mobile-clear-wrap">
                <button type="button" className="filters-bar__mobile-clear-btn" onClick={clearButtonClicked}>
                    WYCZYŚĆ FILTRY <i className="fa fa-times"></i>
                </button>
            </div>

        </div>
    );
}

export default withRouter(FiltersBar);
